import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { inProgramDisplayOrder } from '@/shared/utils/programOrder';
import { PROGRAM_PAGE_URLS } from '@/shared/utils/programInfo';
import { feedbackLinkFor } from '@/features/feedback/feedbackLink';
import { TEAM_EMAIL } from '@/shared/utils/contact';
import './Footer.css';

const PROGRAMS = inProgramDisplayOrder([
    { key: 'si', label: 'SI', full: 'Supplemental Instruction' },
    { key: 'ta', label: 'TA', full: 'Teaching Assistants' },
    { key: 'la', label: 'LA', full: 'Learning Assistants' },
]);

function Footer() {
    const currentYear = new Date().getFullYear();
    const location = useLocation();

    return (
        <footer className="psh-footer bg-dark text-light py-4">
            <Container>
                <Row>
                    <Col md={4} className="mb-3 mb-md-0">
                        {/*
                          Heading LEVEL is semantic, the h5/h6 classes carry the
                          size. Using <h5> here produced a heading-order skip on
                          every page in the app, because page content ends at h1
                          to h3 and the footer then jumped to h5. Assistive
                          technology uses heading order to build the page
                          outline, so keep these at h2/h3 and change only the
                          class if the visual size needs to change.
                        */}
                        <h2 className="h5">Peer Support Hub</h2>
                        <p className="text-light small">
                            Coordinating peer-based instructional support across
                            Learning Assistant, Supplemental Instruction, and
                            Teaching Assistant programs at MSU Denver.
                        </p>
                    </Col>
                    <Col md={4} className="mb-3 mb-md-0">
                        <h3 className="h6">Programs</h3>
                        <ul className="list-unstyled small">
                            {PROGRAMS.map((program) => (
                                <li key={program.key}>
                                    <span
                                        className={`badge badge-${program.key} program-rank-badge me-2`}
                                    >
                                        {program.label}
                                    </span>
                                    <a
                                        href={PROGRAM_PAGE_URLS[program.key]}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {program.full}
                                        <span className="visually-hidden">
                                            {' '}
                                            (opens in a new tab)
                                        </span>
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </Col>
                    <Col md={4}>
                        <h3 className="h6">Links</h3>
                        <ul className="list-unstyled small">
                            <li>
                                <Link to="/about" className="text-muted">
                                    About
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to={feedbackLinkFor(location)}
                                    className="text-muted"
                                >
                                    Send feedback
                                </Link>
                            </li>
                            <li>
                                <a
                                    href={`mailto:${TEAM_EMAIL}`}
                                    className="text-muted"
                                >
                                    Contact us
                                </a>
                            </li>
                            <li>
                                <a
                                    href="https://www.msudenver.edu"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-muted"
                                >
                                    MSU Denver
                                </a>
                            </li>
                        </ul>
                    </Col>
                </Row>
                <hr className="my-3" />
                <Row>
                    <Col className="text-center text-light small">
                        &copy; {currentYear} Metropolitan State University of
                        Denver. All rights reserved.
                    </Col>
                </Row>
            </Container>
        </footer>
    );
}

export default Footer;
